import React from 'react';
import { Navbar } from './Navbar';

export const DashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      {/* Add safe-area-inset-top to account for iOS PWA notch + navbar height */}
      <main 
        className="pb-6 min-h-screen"
        style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 3.5rem)' }}
      >
        {children}
      </main>
    </div>
  );
};
